/**
 * Session messages translated in French and English
 * Used for session expiration and inactivity notifications
 */
export const SESSION_MESSAGES = {
  fr: {
    sessionExpired:
      "Votre session a expiré pour cause d'inactivité. Veuillez vous reconnecter pour continuer.",
    sessionWarning: (minutes: number) =>
      `Votre session expirera dans ${minutes} minute${minutes > 1 ? 's' : ''} en raison d'inactivité.`,
    sessionTimeout: 'Session expirée',
  },
  en: {
    sessionExpired: 'Your session has expired due to inactivity. Please log in again to continue.',
    sessionWarning: (minutes: number) =>
      `Your session will expire in ${minutes} minute${minutes > 1 ? 's' : ''} due to inactivity.`,
    sessionTimeout: 'Session expired',
  },
} as const;

/**
 * Gets the appropriate session message based on language
 */
export function getSessionMessage(
  key: keyof typeof SESSION_MESSAGES.en,
  language: 'fr' | 'en' = 'fr',
  params?: number
): string {
  const messages = SESSION_MESSAGES[language];
  const message = messages[key];

  if (typeof message === 'function' && params !== undefined) {
    return message(params);
  }

  return message as string;
}
